"use client";
import { useEffect, useState } from "react";
import Button from "./Button";
import { Switch } from "@/components/ui/switch";
import cookieDesktopImg from "@/public/cookie-desktop.jpg";
import cookieMobileImg from "@/public/cookie-mobile.jpg";

export const CookieConsent = ({dict}: {dict: any}) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [show, setShow] = useState(false);
  const [isOptionalChecked, setIsOptionalChecked] = useState(true);

  useEffect(() => {
    // Check if 'cookieConsent' is set
    const hasConsent = localStorage.getItem('cookieConsent');
    setShow(!hasConsent);

    // Handle screen size

    const handleChange = () => setIsSmallScreen(mediaQuery.matches);
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    mediaQuery.addEventListener("change", handleChange);
    handleChange();
  }, []);

  const saveEssential = () => {
    if (isOptionalChecked) {
      saveAll();
      return;
    }
    localStorage.setItem('cookieConsent', 'essential');
    window.dispatchEvent(new Event('cookieConsentChanged'));

    setShow(false);
  }

  const saveAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    window.dispatchEvent(new Event('cookieConsentChanged'));

    setShow(false);
  }

  return (
        <div
          className={`transition-all duration-300 ${show ? 'translate-y-0 opacity-100' : 'translate-y-[500px] opacity-0 pointer-none'} flex flex-row-reverse fixed overflow-hidden bottom-0 right-0 md:bottom-6 md:right-6 w-screen md:w-fit md:max-w-[620px] bg-[#8EC490] rounded-tl-3xl rounded-tr-3xl md:rounded-3xl z-50 text-white shadow-sm nowrap`}
          style={{
            'backgroundImage': `url("${isSmallScreen ? cookieMobileImg.src : cookieDesktopImg.src}")`,
            'backgroundSize': 'contain',
            'backgroundRepeat': 'no-repeat',
            'backgroundPosition': isSmallScreen ? 'bottom center' : 'center right'
          }}>
          <div className="relative z-2 md:w-fit md:max-w-[380px] p-6 mb-4 md:mb-0 md:mr-44">
            <h2 className="nowrap w-fit text-xl mb-2">
              {dict.components.cookie_consent.title}
            </h2>
            <p className="text-sm opacity-70 pb-4"> 
              {dict.components.cookie_consent.description}
            </p>
            <div className="pb-4 mt-4 md:mt-0">
              <div className="flex flex-row items-center gap-2 pb-2 opacity-60">
                <Switch id="essential-cookies" className="cursor-default" checked={true} />
                <p className="text-sm">{dict.components.cookie_consent.essential_cookies} </p>
              </div>
              <div className="flex flex-row items-center gap-2">
                <Switch id="essential-cookies" checked={isOptionalChecked} onCheckedChange={v => setIsOptionalChecked(v)} />
                <p className="text-sm">{dict.components.cookie_consent.marketing_cookies}</p>
              </div>
            </div>

            <div className="flex flex-row gap-2 flex-wrap md:flex-nowrap mt-6 md:mt-0">
              <Button className="text-sm transition-colors text-black bg-white hover:bg-gray-200 rounded-3xl h-10 px-6 py-2"
                onClick={saveAll}>
                {dict.components.cookie_consent.accept_all}
              </Button>
              <Button className="backdrop-blur-md text-sm transition-colors bg-white/20 hover:bg-white/30 rounded-3xl h-10 px-6 py-2"
                onClick={saveEssential}>
                {dict.components.cookie_consent.save_preferences}
              </Button>
            </div>
          </div>
        </div>
      )
}